import store from '@/app/store'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component
export default class App extends Vue {
  // TODO: Scroll Funktionalität wird vermutlich in mehreren layouts benötigt.
  // private showScrollButton: boolean = false
  private snacks: boolean = false
  private dialog: boolean = false
  private color: string = 'info'
  private msg: string = ''

  get layout() {
    if (!this || !this.$route || !this.$route.meta) {
      return 'empty-layout'
    }
    return this.$route.meta.layout || 'empty-layout'
  }

  // Hier können vorab Daten in den Store geladen werden, die sich für die
  // Dauer der Session eher selten ändern.
  private async prefetch() {
    // if (this.$auth.isAdmin === false) {
    // }
  }

  // private onScroll(e: any) {
  //   this.showScrollButton = e.target.scrollingElement.scrollTop > 50
  // }

  // private moveToTop() {
  //   this.$vuetify.goTo('#header')
  // }

  private showSnacks(color: string, msg: string) {
    this.color = color
    this.msg = msg
    this.snacks = true
  }

  private showExceptionDialog(msg: string) {
    this.msg = msg
    this.dialog = true
  }

  private created() {
    this.$bus.$on('app.snack.show', this.showSnacks)
    this.$bus.$on('app.exception-dialog.show', this.showExceptionDialog)
    this.$bus.$on('auth.logged-in', this.prefetch)
  }
}
